import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {ListApikeysComponent} from './list-apikeys/list-apikeys.component';
import {FormApikeysComponent} from './form-apikeys/form-apikeys.component';


const routes: Routes = [
  {
    path: '',
    component: ListApikeysComponent,
    pathMatch: 'full'
  },
  {
    path: 'ver',
    component: FormApikeysComponent,
  }
];
@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ApikeysRoutingModule { }
